<template>
  <el-dialog
    :visible="visible"
    title="一键进仓"
    destroy-on-close
    @close="onClose"
  >
    <el-form
      ref="form"
      :model="form"
      :show-message="false"
    >
      <el-form-item
        label="实际进仓时间"
        required
        prop="incomeDate"
      >
        <el-date-picker
          v-model="form.incomeDate"
          type="date"
          value-format="yyyy-MM-dd"
          clearable
        />
      </el-form-item>
    </el-form>
    <p style="color:red">是否确定所有货物都已进仓，且实际进仓信息与预报一致？</p>
    <el-row
      slot="footer"
      style="margin-top:15px;"
    >
      <el-col
        :span="18"
        :offset="6"
      >
        <el-form>
          <span>
            <el-button @click="onClose">取 消</el-button>
            <el-button
              type="primary"
              @click="handleSubmit"
            >确定</el-button>
          </span>
        </el-form>
      </el-col>
    </el-row>
  </el-dialog>
</template>
<script>
import { oneKeyIncome } from '@/api/OMS/warehouseIn'
import { getLoading } from '@/utils/utilBaseElement'
export default {
  name: 'OneKeyIncome',
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    warehouseInUuid: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      form: {
        incomeDate: ''
      }
    }
  },
  methods: {
    handleSubmit() {
      if (!this.form.incomeDate) {
        this.$message.error('实际进仓时间不能为空')
        return
      }
      this.loading = getLoading()
      const params = {
        warehouseInUuid: this.warehouseInUuid,
        incomeDate: this.form.incomeDate
      }
      oneKeyIncome(params)
        .then((res) => {
          this.$message.success('一键进仓成功')
          this.loading.close()
          this.onClose()
        })
        .catch(() => {
          this.loading.close()
        })
    },
    onClose() {
      this.$refs.form.resetFields()
      this.$emit('onClose')
    }
  }
}
</script>
